import { render, staticRenderFns } from "./secTitle.vue?vue&type=template&id=75a109cf&"
import script from "./secTitle.vue?vue&type=script&lang=js&"
export * from "./secTitle.vue?vue&type=script&lang=js&"
import style0 from "./secTitle.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports